// NPM imports

import React, { Component } from 'react';
import { connect } from 'react-redux';

// Project imports

import Modal from '../../../components/Modal';
import AlertMessage from '../../../components/AlertMessage';
import LoadMask from '../../../components/LoadMask';
import { recoverPassword } from '../../../redux/auth';
import { getRecoverPasswordUI } from '../../../redux/selectors';

// Module imports

import ChangePasswordForm from '../../Logged/components/ChangePasswordForm';

// Component

class LoginRecoverPasswordModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showSuccessMessage: false,
    };
  }

  _submit = ({ newPassword }) => {
    const { recoverPasswordToken } = this.props;
    this.props
      .dispatch(recoverPassword(recoverPasswordToken, newPassword))
      .then(
        () => {
          this.setState({ showSuccessMessage: true });
        },
        // error
        () => {},
      );
  };

  _renderContent = () => {
    const { ui } = this.props;

    if (this.state.showSuccessMessage) {
      return (
        <AlertMessage
          box
          success
          message="Senha atualizada com sucesso. Por favor, efetue o login novamente."
        />
      );
    }

    return (
      <div>
        <p>Defina uma nova senha para começar a utilizar a plataforma.</p>
        <ChangePasswordForm ui={ui} onlyNewPassword onSubmit={this._submit} />
      </div>
    );
  };

  render() {
    const { ui } = this.props;

    return (
      <Modal title="Recuperar senha" size="small" {...this.props}>
        {this._renderContent()}
        {ui.isFetching && <LoadMask text="Alterando..." />}
      </Modal>
    );
  }
}

// Redux

const mapStateToProps = state => ({
  ui: getRecoverPasswordUI(state),
});

export default connect(mapStateToProps)(LoginRecoverPasswordModal);
